var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorBenefits1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86.769,
    height: 86.819,
    viewBox: "0 0 86.769 86.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25631",
    "data-name": "Rectangle 25631",
    width: 86.769,
    height: 86.819,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88049",
    "data-name": "Group 88049",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88048",
    "data-name": "Group 88048",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308520",
    "data-name": "Path 308520",
    d: "M24.879,44.256,18,36.945a8.218,8.218,0,0,0-5.988-2.591H9.176A8.244,8.244,0,0,0,.944,42.609V57.055H15.553V43.966l5.387,5.726a3.709,3.709,0,0,0,2.7,1.168H32.1a3.3,3.3,0,0,0,0-6.6Z",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308521",
    "data-name": "Path 308521",
    d: "M12.448,34.367c-.144-.008-.289-.012-.434-.012H9.176A8.243,8.243,0,0,0,.945,42.61V57.056H4.653V42.61A8.245,8.245,0,0,1,12.448,34.367Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308522",
    "data-name": "Path 308522",
    d: "M18.9,47.523l2.041,2.17a3.708,3.708,0,0,0,2.7,1.167H32.1a3.3,3.3,0,0,0,3.292-3.337Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308523",
    "data-name": "Path 308523",
    d: "M.945,57.056H17.4c3.073,0,5.563,2.49,5.563,6.489v22.4h-7.3V67.374H6.506A5.561,5.561,0,0,1,.945,61.812Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308524",
    "data-name": "Path 308524",
    d: "M4.653,61.812V57.056H.945v4.756a5.561,5.561,0,0,0,5.561,5.562h3.708a5.561,5.561,0,0,1-5.561-5.562",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308525",
    "data-name": "Path 308525",
    d: "M22.962,80.518a1.205,1.205,0,1,1-1.2,1.205,1.205,1.205,0,0,1,1.2-1.205",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308526",
    "data-name": "Path 308526",
    d: "M9.319,15.542a7.787,7.787,0,1,0,7.787,7.787,7.8,7.8,0,0,0-7.787-7.787",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308527",
    "data-name": "Path 308527",
    d: "M61.89,44.256l6.878-7.311a8.218,8.218,0,0,1,5.988-2.591h2.837a8.244,8.244,0,0,1,8.232,8.255V57.055H71.216V43.966l-5.387,5.726a3.709,3.709,0,0,1-2.7,1.168H54.667a3.3,3.3,0,0,1,0-6.6Z",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308528",
    "data-name": "Path 308528",
    d: "M74.322,34.367c.144-.008.289-.012.434-.012h2.837a8.243,8.243,0,0,1,8.232,8.255V57.056H82.117V42.61A8.245,8.245,0,0,0,74.322,34.367Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308529",
    "data-name": "Path 308529",
    d: "M67.87,47.523l-2.041,2.17a3.708,3.708,0,0,1-2.7,1.167H54.667a3.3,3.3,0,0,1-3.292-3.337Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308530",
    "data-name": "Path 308530",
    d: "M85.825,57.056H69.37c-3.072,0-5.563,2.49-5.563,6.489v22.4h7.305V67.374h9.151a5.562,5.562,0,0,0,5.562-5.562Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308531",
    "data-name": "Path 308531",
    d: "M82.117,61.812V57.056h3.708v4.756a5.562,5.562,0,0,1-5.562,5.562H76.555a5.562,5.562,0,0,0,5.562-5.562",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308532",
    "data-name": "Path 308532",
    d: "M63.807,80.518a1.205,1.205,0,1,1-1.2,1.205,1.205,1.205,0,0,1,1.2-1.205",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308533",
    "data-name": "Path 308533",
    d: "M77.45,15.542a7.787,7.787,0,1,0,7.787,7.787,7.8,7.8,0,0,0-7.787-7.787",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308534",
    "data-name": "Path 308534",
    d: "M62.439,11.414H40.878a3.194,3.194,0,0,0-3.194,3.194V21a3.194,3.194,0,0,0,3.194,3.194H58.4l7.234,4.791V14.608a3.194,3.194,0,0,0-3.194-3.194",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308535",
    "data-name": "Path 308535",
    d: "M24.33.927H45.891a3.194,3.194,0,0,1,3.194,3.194v6.388A3.194,3.194,0,0,1,45.891,13.7H28.37l-7.234,4.791V4.121A3.194,3.194,0,0,1,24.33.927",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308536",
    "data-name": "Path 308536",
    d: "M28.038.927H24.33a3.194,3.194,0,0,0-3.194,3.194V18.494l3.708-2.456V4.121A3.194,3.194,0,0,1,28.038.927",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308537",
    "data-name": "Path 308537",
    d: "M49.085,12.106V2.524a1.6,1.6,0,0,0-1.6-1.6H45.819A.071.071,0,0,0,45.748,1V8.7a1.669,1.669,0,0,1-1.669,1.669H37.825a1.669,1.669,0,0,0,0,3.337h9.663A1.6,1.6,0,0,0,49.085,12.106Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308538",
    "data-name": "Path 308538",
    d: "M62.438,10.487H50.012V4.121A4.126,4.126,0,0,0,45.89,0H24.33a4.125,4.125,0,0,0-4.121,4.121V18.494a.934.934,0,0,0,1.439.773l7-4.637h8.108V21a4.126,4.126,0,0,0,4.121,4.121H58.12l7,4.637a.933.933,0,0,0,1.439-.773V14.608a4.126,4.126,0,0,0-4.122-4.121M28.37,12.776a.924.924,0,0,0-.512.154l-5.8,3.838V4.121A2.27,2.27,0,0,1,24.33,1.854H45.89a2.27,2.27,0,0,1,2.268,2.267v6.388a2.27,2.27,0,0,1-2.268,2.267Zm18.811,5.953h-3a.927.927,0,0,1,0-1.854h3a.927.927,0,1,1,0,1.854m12.757,0H51.713a.927.927,0,1,1,0-1.854h8.225a.927.927,0,1,1,0,1.854Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308539",
    "data-name": "Path 308539",
    d: "M35.056,8.242H26.831a.927.927,0,1,1,0-1.854h8.225a.927.927,0,1,1,0,1.854",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308540",
    "data-name": "Path 308540",
    d: "M42.592,8.242h-3a.927.927,0,1,1,0-1.854h3a.927.927,0,1,1,0,1.854",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308541",
    "data-name": "Path 308541",
    d: "M85.842,84.965H82.086V68.038a6.5,6.5,0,0,0,4.666-6.226V42.61a9.181,9.181,0,0,0-9.159-9.182H74.756a9.181,9.181,0,0,0-6.663,2.882l-6.6,7.019H54.667a4.229,4.229,0,0,0-3.489,6.6H35.591a4.228,4.228,0,0,0-3.489-6.6H25.28l-6.6-7.019a9.179,9.179,0,0,0-6.662-2.882H9.176A9.18,9.18,0,0,0,.018,42.61v19.2a6.5,6.5,0,0,0,4.665,6.226V84.965H.927a.927.927,0,0,0,0,1.854H85.842a.927.927,0,0,0,0-1.854M54.667,45.183H61.89a.926.926,0,0,0,.675-.291l6.879-7.312a7.32,7.32,0,0,1,5.312-2.3h2.838a7.324,7.324,0,0,1,7.3,7.328V56.129H72.143V43.967a.933.933,0,0,0-1.6-.635l-5.387,5.726a2.794,2.794,0,0,1-2.026.875H54.667a2.375,2.375,0,0,1,0-4.75ZM1.872,42.61a7.324,7.324,0,0,1,7.3-7.328h2.838a7.324,7.324,0,0,1,5.312,2.3L24.2,44.892a.928.928,0,0,0,.676.291H32.1a2.375,2.375,0,0,1,0,4.75H23.641a2.792,2.792,0,0,1-2.025-.875l-5.387-5.726a.933.933,0,0,0-1.6.635V56.129H1.872ZM15.658,82.425a.928.928,0,0,0,.927-.927V67.374a.927.927,0,0,0-.927-.927H6.507a4.64,4.64,0,0,1-4.635-4.635V57.983H17.4a4.64,4.64,0,0,1,4.635,4.635V77.186a.927.927,0,1,0,1.854,0V62.618A6.5,6.5,0,0,0,17.4,56.129h-.919V46.305l3.784,4.023a4.655,4.655,0,0,0,3.376,1.459h18.8V84.965H6.537V68.3h8.194V81.5a.926.926,0,0,0,.927.927m55.454.185a.927.927,0,0,0,.927-.927V68.3h8.193V84.965H44.294V51.787H63.128A4.653,4.653,0,0,0,66.5,50.328l3.785-4.023v9.823h-.92a6.5,6.5,0,0,0-6.489,6.489V77.186a.927.927,0,1,0,1.854,0V62.617a4.641,4.641,0,0,1,4.635-4.635H84.9v3.83a4.641,4.641,0,0,1-4.635,4.635H71.112a.927.927,0,0,0-.927.927V81.683A.927.927,0,0,0,71.112,82.61Z",
    fill: "#515255"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorBenefits1);
export default __webpack_public_path__ + "static/media/Mentor_Benefits_1.bfb30e5a03fbab8381aec60800799879.svg";
export { ForwardRef as ReactComponent };